import { toBounds } from '../utils';
export class Isochrone {
  constructor(duration, geometry) {
    this.duration = duration;
    this.geometry = geometry;
    this.bounds = toBounds(geometry);
  }
}